export default __webpack_public_path__ + "static/media/datasets.2ed7d16d.svg";